export default __webpack_public_path__ + "static/resource-block_navigating-SEL-e8dd52162666086f2d9ae7faa3d53f61.jpg";